
export const firebaseConfig = {
    apiKey: "AIzaSyBDLOe8xllkYussGYPDFrRB6Bau2U5oAD4",
    authDomain: "gamephotogallery.firebaseapp.com",
    databaseURL: "https://gamephotogallery.firebaseio.com",
    projectId: "gamephotogallery",
    storageBucket: "gamephotogallery.appspot.com",
    messagingSenderId: "1014730556751",
    appId: "1:1014730556751:web:823c9f41e3e8cd0828f13a",
    measurementId: "G-P2PBZ05765"
  };
  // Initialize Firebase
  

  
  
  
